export default "__VITE_ASSET__392e65a5__"